import {
  EnvelopeClosedSquaredIcon,
  PrinterIcon,
  ShareIcon,
} from "components/page-components/Icons/small"

import {
  XingIconSolid,
  LinkedinIconSolid,
  TwitterXIconSolid,
  FacebookIconSolid,
  WhatsappIconSolid,
} from "components/page-components/Icons/brands"

import React, { useState } from "react"

export const ShareArticle = ({ seo_title, description, path }) => {
  const [share_modal_open, set_share_modal_open] = useState(false)

  const open_share_modal = (e) => {
    e.preventDefault()
    set_share_modal_open(true)
  }
  const close_share_modal = () => set_share_modal_open(false)

  const shareURL = `https://bi-medien.de/${path}`

  const print_on_click = (e) => {
    e.preventDefault()
    if (typeof window !== "undefined") {
      window.print()
    }
  }

  return (
    <div
      data-nosnippet
      className="is-flex is-flex-direction-row"
      style={{ height: "100%" }}
    >
      <a
        href=" #"
        className="ml-auto has-text-centered"
        title="Artikel drucken"
        onClick={open_share_modal}
      >
        <ShareIcon />
        <p className="mt-3 has-text-mitternachtsblau subtitle is-7">Teilen</p>
      </a>
      <a
        href=" #"
        className="ml-6 has-text-centered"
        title="Artikel drucken"
        onClick={print_on_click}
      >
        <PrinterIcon />
        <p className="mt-3 has-text-mitternachtsblau subtitle is-7">Drucken</p>
      </a>
      <ShareArticleModal
        {...{
          shareURL,
          seo_title,
          description,
          share_modal_open,
          close_share_modal,
        }}
      />
    </div>
  )
}

const ShareArticleModal = ({
  shareURL,
  seo_title,
  description,
  share_modal_open,
  close_share_modal,
}) => {
  return (
    <div
      data-nosnippet
      className={`modal${share_modal_open ? " is-active" : ""}`}
    >
      <div
        className="modal-background"
        onClick={close_share_modal}
        role="button"
        tabIndex="-1"
        onKeyDown={() => {}}
        aria-label="Close Fail Modal"
      ></div>
      <div className="modal-content" style={{ maxWidth: 745 }}>
        <div
          className="box m-auto is-flex is-flex-direction-column p-5"
          style={{ minHeight: 300, maxWidth: 735 }}
        >
          <p className="title is-4 has-text-mitternachtsblau">Beitrag teilen</p>

          <div className="field is-grouped is-grouped-multiline is-justify-content-center m-auto">
            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`https://www.xing.com/spi/shares/new?url=${shareURL}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#026466" }}
                title="Auf Xing teilen"
              >
                <XingIconSolid {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  Xing
                </p>
              </a>
            </div>

            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`https://www.linkedin.com/shareArticle?url=${shareURL}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#2867B2" }}
                title="Auf LinkedIn teilen"
              >
                <LinkedinIconSolid {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  LinkedIn
                </p>
              </a>
            </div>

            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}`}
                target="_blank"
                rel="noopener noreferrer"
                title="Auf Facebook teilen"
              >
                <FacebookIconSolid {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  Facebook
                </p>
              </a>
            </div>

            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`https://twitter.com/intent/tweet?url=${shareURL}&text=${encodeURIComponent(
                  seo_title
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#00acee" }}
                title="Artikel tweeten"
              >
                <TwitterXIconSolid {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  Twitter
                </p>
              </a>
            </div>

            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`whatsapp://send?text=${shareURL}%0a‎${seo_title}%0a‎${description}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#034055" }}
                title="Artikel per WhatsApp teilen"
              >
                <WhatsappIconSolid {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  WhatsApp
                </p>
              </a>
            </div>

            <div className="has-text-centered py-4" style={{ minWidth: 110 }}>
              <a
                href={`mailto:?subject=Artikel von bi-medien.de: ${seo_title}&body=${description} ${shareURL}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#034055" }}
                title="Artikel per Mail senden"
              >
                <EnvelopeClosedSquaredIcon {...{ size: 1.3 }} />
                <p className="mt-3 has-text-mitternachtsblau subtitle is-7">
                  E-Mail
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
